export const artQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The women are painting a canvas.",
      B: "The women are arranging pottery on a shelf.",
      C: "The women are shaping clay on a pottery wheel.",
      D: "The women are carving designs into wood.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성들이 도예 물레에서 점토를 성형하고 있음\n" +
      "오답 설명: (A) 캔버스에 그림을 그리지 않음, (B) 도자기를 진열하지 않음, (D) 나무를 조각하지 않음",
  },

  {
    questionNumber: 2,
    choices: {
      A: "The man is assembling a metal model.",
      B: "The man is sketching a design on paper.",
      C: "A wooden piece is being carved.",
      D: "A glass sculpture is being polished.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 나무 조각을 깎고 있음\n" +
      "오답 설명: (A) 금속 모형을 조립하지 않음, (B) 디자인을 스케치하지 않음, (D) 유리 조각을 닦지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The woman is tuning the piano.",
      B: "A song is being composed on the piano.",
      C: "A piece of music is being played on the piano.",
      D: "The woman is closing the piano lid.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 피아노로 음악을 연주하고 있음\n" +
      "오답 설명: (A) 피아노를 조율하지 않음, (B) 곡을 작곡하지 않음, (D) 피아노 뚜껑을 닫지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The woman is adjusting the violin strings.",
      B: "The woman is performing on the violin.",
      C: "The woman is composing sheet music.",
      D: "The woman is polishing the violin.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 바이올린을 연주하고 있음\n" +
      "오답 설명: (A) 바이올린 줄을 조정하지 않음, (C) 악보를 작곡하지 않음, (D) 바이올린을 닦지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "The dancer is tying her ballet shoes.",
      B: "The dancer is stretching on the floor.",
      C: "The dancer is adjusting her costume.",
      D: "The dancer is performing on stage.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 무대에서 춤을 추고 있음\n" +
      "오답 설명: (A) 발레 슈즈를 묶지 않음, (B) 바닥에서 스트레칭하지 않음, (C) 의상을 조정하지 않음",
  },

  {
    questionNumber: 6,
    choices: {
      A: "A camera is mounted on a tripod.",
      B: "The woman is holding a telescope.",
      C: "The woman is taking notes.",
      D: "The woman is sitting on the ground.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 카메라가 삼각대에 장착되어 있음\n" +
      "오답 설명: (B) 망원경이 아닌 카메라임, (C) 필기하지 않음, (D) 바닥에 앉아있지 않음",
  },

  {
    questionNumber: 7,
    choices: {
      A: "The woman is sharpening a pencil.",
      B: "The woman is cutting paper.",
      C: "The woman is sketching on paper.",
      D: "The woman is measuring something.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 종이에 스케치를 하고 있음\n" +
      "오답 설명: (A) 연필을 깎지 않음, (B) 종이를 자르지 않음, (D) 측정하지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "An artwork is in progress.",
      B: "A wall is being decorated.",
      C: "The woman is putting on an apron.",
      D: "The woman is dipping a brush in paint.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 예술 작업이 진행되고 있음\n" +
      "오답 설명: (B) 벽을 장식하지 않음, (C) 이미 앞치마를 입고 있음, (D) 붓에 물감을 묻히지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A palette is being held in one hand.",
      B: "A palette is being cleaned.",
      C: "A palette is being placed on a table.",
      D: "A palette is being thrown away.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 팔레트를 한 손에 들고 있음\n" +
      "오답 설명: (B) 팔레트를 청소하지 않음, (C) 테이블에 놓지 않음, (D) 팔레트를 버리지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "A man is grasping a tool.",
      B: "A man is putting on an apron.",
      C: "Clay is being molded.",
      D: "A statue is being painted.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 도구를 잡고 있음\n" +
      "오답 설명: (B) 이미 앞치마를 입고 있음, (C) 클레이가 아닌 돌을 다루고 있음, (D) 조각상을 칠하지 않음",
  },

  {
    questionNumber: 11,
    choices: {
      A: "Several people are standing near the artwork.",
      B: "The gallery walls are covered with photographs.",
      C: "A woman is looking at a painting.",
      D: "The woman is taking a picture of the painting.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성이 그림을 보고 있음\n" +
      "오답 설명: (A) 여러 명이 서있지 않음, (B) 사진이 아닌 그림이 걸려있음, (D) 사진을 찍지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "The woman is putting on earphones.",
      B: "A woman is bending forward.",
      C: "The paintings are leaning against the wall.",
      D: "The woman is adjusting the frames.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여성이 앞으로 몸을 숙이고 있음\n" +
      "오답 설명: (A) 이미 이어폰을 착용하고 있음, (C) 그림이 벽에 걸려있음, (D) 액자를 조정하지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The paintings are lying on the floor.",
      B: "The gallery is empty.",
      C: "A group of people is admiring the artwork.",
      D: "The visitors are taking pictures of the paintings.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "오답 설명: (A) 그림들이 벽에 걸려 있음 → 위치 오류, (B) 갤러리에 여러 명의 방문객이 있음 → 상황 오류, (D) 사람들이 그림을 보고 있지만 사진을 찍고 있지는 않음 → 동작 오류",
  },
  {
    questionNumber: 14,
    choices: {
      A: "The artwork is being hung on the wall.",
      B: "The paintings are placed on the floor.",
      C: "A woman is contemplating a painting.",
      D: "The woman is listening to an art description.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성이 그림을 깊이 감상하고 있음\n" +
      "오답 설명: (A) 작품이 이미 벽에 걸려있음, (B) 그림이 바닥이 아닌 벽에 있음, (D) 작품 설명을 듣지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The man is pointing at the artwork.",
      B: "The paintings are placed on the floor.",
      C: "The man is holding a brochure.",
      D: "A couple is observing the paintings.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 커플이 그림들을 감상하고 있음\n" +
      "오답 설명: (A) 작품을 가리키지 않음, (B) 그림이 바닥이 아닌 벽에 있음, (C) 남자가 브로셔를 들고 있지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "A man is studying a painting.",
      B: "The man is taking notes.",
      C: "The paintings are leaning against the wall.",
      D: "The man is listening to an art description.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 그림을 자세히 보고 있음\n" +
      "오답 설명: (B) 노트를 작성하지 않음, (C) 그림이 벽에 걸려있음, (D) 작품 설명을 듣지 않음",
  },
];
